/* Testimonials — scroll-snap slider, prev/next arrows + autoplay. ~0.8KB. */
(function () {
  document.querySelectorAll('[data-ts]').forEach(function (track) {
    var items = Array.prototype.slice.call(track.querySelectorAll('.ts__item'));
    if (items.length < 2) return;
    var arrowsWrap = track.parentElement.querySelector('[data-ts-arrows]');
    var prev = track.parentElement.querySelector('[data-ts-prev]');
    var next = track.parentElement.querySelector('[data-ts-next]');
    var interval = parseInt(track.getAttribute('data-ts-autoplay'), 10) || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer, raf;

    function step() {
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return items[0].getBoundingClientRect().width + gap;
    }

    // Everything already fits — no slider needed.
    if (track.scrollWidth <= track.clientWidth + 2) {
      if (arrowsWrap) arrowsWrap.style.display = 'none';
      return;
    }

    function update() {
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(update);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); reset(); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); reset(); });

    function reset() {
      if (!interval || reduce) return;
      clearInterval(timer);
      timer = setInterval(function () {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        }
      }, interval);
    }
    track.addEventListener('mouseenter', function () { clearInterval(timer); });
    track.addEventListener('mouseleave', reset);
    update();
    reset();
  });
})();
